import { Link } from 'react-router';

import logoImage from '@/images/logotype.svg';

import s from './logo.module.css';

function Logo() {
  return (
    <Link to="/" className={s.logo}>
      <img src={logoImage} alt="logo" />
    </Link>
  );
}

export default Logo;
